<template>
    <div class="history-wrapper">
        <div class="history"><img src="../../assets/img/history/down.jpg" alt=""></div>
        <div class="history"><img src="../../assets/img/history/history.jpg" alt=""></div>
    </div>
</template>

<script>
    export default {
        name: "HsHistory"
    }
</script>

<style scoped>
    .history-wrapper {
        width: 100%;
    }
    .history {
        width: 1250px;
        margin: 0 auto;
        background-color: #fff;
    }
</style>